
export const DROPDOWN_TYPES = {
  TASK_MOVEMENT_TRANSPORT: 'taskMovementTransport',
  CUSTOMER: 'customer',
  PRODUCT: 'product',
};

export const DROPDOWN_DEFAULTS = {
  PAGE_NUMBER: 1,
  PAGE_SIZE: 50,
  MAX_PAGE_SIZE: 100,
  SEARCH_DEBOUNCE_MS: 300,
};

export const DROPDOWN_CONFIG = {
  [DROPDOWN_TYPES.TASK_MOVEMENT_TRANSPORT]: {
    name: 'Task Movement Transport',
    isPaginated: false,
    totalItems: 8,
  },
  [DROPDOWN_TYPES.CUSTOMER]: {
    name: 'Customer',
    isPaginated: true,
    totalItems: 855,
  },
  [DROPDOWN_TYPES.PRODUCT]: {
    name: 'Product',
    isPaginated: true,
    totalItems: 976,
  },
};